import React, { useEffect } from 'react'
import landingBg from './landing.jpeg'

function Landing({ setIsLandingVisible }) {


    return (
        <div className='home_container' style={{ overflow: 'hidden', maxHeight: '100vh', position: 'relative' }}>
            <div className='glass' style={{ height: '100vh', width: '100vw', position: 'fixed', zIndex: '9999', top: '0', right: '0', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <img src={landingBg} style={{ height: '100vh', width: '100vw', overflow: 'hidden', position: 'absolute' }} />
                <div style={{ zIndex: '99999', position: 'absolute', top: '10px', left: '10px', margin: '0px 20px' }}>
                    <h1 style={{ color: '#fff', fontWeight: '600' }}>RadioBig</h1>
                </div>
                <div style={{ position: 'absolute', bottom: '40px', right: '40px', display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
                    <button id="butn" className='glass hover' onClick={() => { setIsLandingVisible(false) }} style={{ padding: '15px 35px', cursor: 'pointer', background: 'none', border: '1px solid #fff', borderRadius: '50vh', color: '#fff', fontSize: '1.5em', width: 'fit-content' }}>Get started</button>
                    <h1 style={{ maxWidth: '30vw', color: '#fff', textAlign: 'right', fontSize: '2em', zIndex: '99' }}>
                        Chill with lofi beats along with nature sounds. Filter according to your wish and have a fun time.
                    </h1>

                </div>
            </div>
        </div>
    )
}

export default Landing